import { ALL_BU } from "constants/DashboardContanst";
import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactDrawer from "react-drawer";
import "react-drawer/lib/react-drawer.css";
//i18n
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  ROLE_ADMIN,
  TENANT_CODE_HEADER,
} from "store/auth/login/actionTypes";
import {
  GET_LIST_BU_STORE_HEADER_SUCCESS,
  GET_LIST_BU_TENANT_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  default as logoDark,
  default as logoLight,
} from "../../assets/images/logo1.png";
import {
  default as logo,
  default as logoLightSvg,
} from "../../assets/images/logo2.png";
// Redux Store
import {
  getCurrentTime,
  getListBUStoreHeader,
  getListBUTenantHeader,
  getListTenantHeader,
  setBUStoreHeader,
  setBUTenantHeader,
  setTenantCodeHeader,
  showRightSidebarAction,
  toggleLeftmenu,
} from "../../store/actions";
import RightSidebar from "../CommonForBoth/RightSidebar";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
const Header = props => {
  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);

  const toggleTopDrawer = () => {
    setPosition("right");
    setOpen(!open);
  };

  const onDrawerClose = () => {
    setOpen(false);
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const Dashboard = useSelector(state => state.Dashboard);

  const {
    listTenant,
    tenantCodeHeader,
    listBuOfTenant,
    listBuStore,
    buTenantHeader,
    buStoreHeader,
    buSelect,
    storeSelect,
    type,
  } = Dashboard;

  const [isShowSelectTenant, setIsShowSelectTenant] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);

  const [selectedBU, setSelectedBU] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  // Chi nhánh đang hiển thị: ưu tiên state local để đổi ngay khi user chọn
  // (buSelect trong store chỉ được set sau khi api load xong danh sách đơn vị),
  // fallback về store cho lần load đầu / khi được set từ nơi khác
  const buCurrent = selectedBU || buSelect;

  const dispatch = useDispatch();

  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      // Check if User admin thì cho chọn tenant
      if (roleUser === ROLE_ADMIN) {
        setIsShowSelectTenant(true);
      } else {
        // Không phải admin thì mặc định tenant của user login
        setIsShowSelectTenant(false);
        const tenantCode = info["userInfo"]["tenantCode"];
        dispatch(setTenantCodeHeader(tenantCode));
      }
    }
    dispatch(getCurrentTime());
  }, []);

  useEffect(() => {
    if (isShowSelectTenant) {
      dispatch(getListTenantHeader());
    }
  }, [isShowSelectTenant]);

  // Thay đổi chi nhánh
  const onChangeBU = ({ selectedBU }) => {
    setSelectedBU(selectedBU);
    if (selectedBU?.value === ALL_BU) {
      console.log(`Lấy thông tin cấu hình theo chi nhánh ${selectedBU.label}`, {
        selectedBU,
      });
      dispatch(
        setBUStoreHeader(selectedBU.code, selectedBU.code, selectedBU, null)
      );
      localStorage.removeItem(BU_STORE_HEADER);
    } else {
      // gọi api get danh sách đơn vị của chi nhánh
      console.log(
        `Gọi api get danh sách đơn vị của chi nhánh ${selectedBU.label}`,
        selectedBU.value
      );
      dispatch(getListBUStoreHeader(selectedBU.value));
    }
    dispatch(setBUTenantHeader(selectedBU.code, selectedBU));
  };

  // Thay đổi đơn vị
  const onChangeStore = ({ selectedStore }) => {
    dispatch(
      setBUStoreHeader(
        buCurrent.code,
        selectedStore.value,
        buCurrent,
        selectedStore
      )
    );
    setSelectedStore(selectedStore);
  };

  useEffect(() => {
    if (tenantCodeHeader) {
      console.log("Thông tin chi nhánh/đơn vị", {
        listBuOfTenant,
        buTenantHeader,
        buSelect,
        listBuStore,
        buStoreHeader,
        storeSelect,
      });
      if (listBuOfTenant?.length === 0) {
        console.log("Gọi api get danh sách chi nhánh", listBuOfTenant);
        dispatch(getListBUTenantHeader());
      }
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (listTenant && listTenant.length > 0) {
      const tenantCode = localStorage.getItem(TENANT_CODE_HEADER);
      if (tenantCode) {
        const value = listTenant.find(item => item.value === tenantCode);
        setSelectedTenant(value);
      } else {
        // Set mặc định tenant
        setSelectedTenant(listTenant[0]);
      }
    }
  }, [listTenant]);

  useEffect(() => {
    switch (type) {
      case GET_LIST_BU_TENANT_HEADER_SUCCESS:
        if (listBuOfTenant.length > 0) {
          console.log("Danh sách chi nhánh thay đổi", {
            listBuOfTenant,
            selectedBU,
            buSelect,
          });
          let firstBU =
            listBuOfTenant?.length > 1
              ? listBuOfTenant[1]
              : listBuOfTenant?.[0];
          const localBU = localStorage.getItem(BU_TENANT_HEADER);
          if (!buSelect && localBU) {
            console.log(`Load lại chi nhánh từ local storage: ${localBU}`);
            firstBU = listBuOfTenant.find(item => item.code === localBU);
          }
          console.log(`Chi nhánh mặc định: ${firstBU?.label}`, firstBU);
          if (firstBU) {
            setSelectedBU(firstBU);
            onChangeBU({ selectedBU: firstBU });
          }
        } else {
          setSelectedBU(null);
        }
        break;
      case GET_LIST_BU_STORE_HEADER_SUCCESS:
        console.log("Danh sách đơn vị thay đổi", {
          listBuStore,
          selectedBU,
          buSelect,
          selectedStore,
          storeSelect,
        });
        const buFInal = selectedBU || buSelect;
        if (!buFInal) {
          return;
        }

        if (listBuStore && listBuStore.length > 0) {
          console.log(`Load đơn vị mặc định cho chi nhánh: ${buFInal?.label}`, {
            buFInal,
            listBuStore,
          });
          let firstStore =
            listBuStore?.length > 1 ? listBuStore[1] : listBuStore?.[0];
          const localStore = localStorage.getItem(BU_STORE_HEADER);
          if (!buSelect && localStore) {
            console.log(`Load lại đơn vị từ local storage: ${localStore}`);
            firstStore = listBuStore.find(item => item.value === localStore);
          }
          console.log(`Đơn vị mặc định: ${firstStore?.label}`, firstStore);
          if (firstStore) {
            setSelectedStore(firstStore);
            dispatch(
              setBUStoreHeader(
                buFInal.code,
                firstStore.value,
                buFInal,
                firstStore
              )
            );
          }
        } else if (listBuStore && listBuStore.length === 0) {
          // Thay đổi chi nhánh (TH không có đơn vị nào)
          console.log(
            `Chi nhánh không có đơn vị. Lấy thông tin cấu hình theo chi nhánh ${buFInal.label}`,
            { buFInal }
          );
          dispatch(setBUStoreHeader(buFInal.code, buFInal.code, buFInal, null));
          setSelectedStore(null);
        }
        break;

      default:
        break;
    }
  }, [type]);

  // Đồng bộ ngược từ store về state local khi chi nhánh được set từ nơi khác
  // (load lại từ local storage, hoặc reset khi set chi nhánh/đơn vị bị lỗi)
  useEffect(() => {
    if (buSelect?.code !== selectedBU?.code) {
      setSelectedBU(buSelect);
    }
  }, [buSelect]);

  // Thay đổi tenant thì lưu vào local storage (x-tenant header)
  useEffect(() => {
    if (selectedTenant) {
      dispatch(setTenantCodeHeader(selectedTenant.value));
    }
  }, [selectedTenant]);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={logoLightSvg}
                    alt=""
                    height="22"
                    style={{ marginLeft: "23px" }}
                  />
                </span>
                <span className="logo-lg">
                  <img
                    style={{
                      transform: "scale(0.5)",
                      marginLeft: "-88px",
                    }}
                    src={logoLight}
                    alt=""
                    height="90"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            {listTenant?.length > 1 && (
              <React.Fragment>
                <div
                  className="d-flex align-items-center"
                  style={{
                    marginRight: "12px",
                    // marginLeft: "30px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Tenant:
                </div>
                {isShowSelectTenant ? (
                  <div
                    className="app-search d-lg-block"
                    style={{ minWidth: "200px", marginTop: "10px" }}
                  >
                    <Select
                      placeholder="Chọn Tenant muốn xem dữ liệu..."
                      value={selectedTenant}
                      onChange={e => {
                        setSelectedTenant(e);
                      }}
                      options={listTenant}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "white" }}
                  >
                    {tenantCodeHeader ? tenantCodeHeader : "Không hợp lệ"}
                  </div>
                )}
              </React.Fragment>
            )}

            <React.Fragment>
              <div
                className="d-flex align-items-center"
                style={{
                  marginRight: "12px",
                  marginLeft: "30px",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Chi nhánh:
              </div>
              {listBuOfTenant && listBuOfTenant.length > 1 ? (
                <div
                  className="app-search d-lg-block"
                  style={{ minWidth: "200px", marginTop: "10px" }}
                >
                  <Select
                    placeholder="Chi nhánh..."
                    value={buCurrent}
                    onChange={e => {
                      onChangeBU({ selectedBU: e });
                    }}
                    options={listBuOfTenant}
                    classNamePrefix="select2-selection"
                  />
                </div>
              ) : (
                <div
                  className="d-flex align-items-center"
                  style={{
                    color: "white",
                  }}
                >
                  {buCurrent && buCurrent.label}
                </div>
              )}
            </React.Fragment>
            {buCurrent?.code !== ALL_BU &&
              listBuStore &&
              listBuStore.length > 0 && (
                <React.Fragment>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      marginRight: "12px",
                      marginLeft: "30px",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Đơn vị:
                  </div>
                  {listBuStore.length > 1 ? (
                    <div
                      className="app-search d-lg-block"
                      style={{ minWidth: "200px", marginTop: "10px" }}
                    >
                      <Select
                        placeholder="Chọn đơn vị..."
                        value={storeSelect}
                        onChange={e => {
                          console.log(
                            `Lấy thông tin cấu hình theo đơn vị ${e.label}`,
                            { e, selectedBU, buSelect }
                          );
                          onChangeStore({ selectedStore: e });
                        }}
                        options={listBuStore}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  ) : (
                    <div
                      className="d-flex align-items-center"
                      style={{
                        color: "white",
                      }}
                    >
                      {storeSelect && storeSelect.label}
                    </div>
                  )}
                </React.Fragment>
              )}

            <div className="dropdown-mega d-none d-lg-block ms-2"></div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* <LanguageDropdown /> */}

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  toggleFullscreen();
                }}
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div> */}

            <NotificationDropdown />

            <ProfileMenu />

            {/* <div className="dropdown d-inline-block">
              <button
                onClick={toggleTopDrawer}
                disabled={open}
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
      <ReactDrawer open={open} position={position} onClose={onDrawerClose}>
        <RightSidebar onClose={onDrawerClose} />
      </ReactDrawer>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
